import React from 'react';
import { Chip, Tooltip, Typography, Box } from '@mui/material';
import { Post, PostStatus } from '../types/api';
import {
  getPostStatusColor,
  getPostStatusLabel,
  getPostStatusSnippet,
} from '../../utils/postStatus';

interface PostStatusBadgeProps {
  post: Post;
  showSnippet?: boolean;
}

const PostStatusBadge: React.FC<PostStatusBadgeProps> = ({ post, showSnippet = true }) => {
  const snippet = showSnippet ? getPostStatusSnippet(post) : null;
  const label = getPostStatusLabel(post.status);

  return (
    <Box>
      <Tooltip title={post.status}>
        <Chip label={label} color={getPostStatusColor(post.status)} size="small" />
      </Tooltip>
      {snippet && (
        <Typography
          variant="caption"
          color={post.status === 'FAILED' ? 'error' : 'text.secondary'}
          display="block"
          sx={{ mt: 0.5, maxWidth: 220 }}
        >
          {snippet}
        </Typography>
      )}
      {post.status === 'SCHEDULED' && post.is_scheduled_in_celery === false && (
        <Typography variant="caption" color="error" display="block" sx={{ mt: 0.25 }}>
          Not queued in scheduler
        </Typography>
      )}
    </Box>
  );
};

export default PostStatusBadge;
